import IdentityType from "../constants/IdentityType";
import { PageStatus } from "../hooks/useInterviewUpdater";

/**
 * Maps form data and interview state to an onboarding page submit request object.
 * 
 * @param {string} identityType - The type of identity ("Agent" or "Agency") from IdentityType enum
 * @param {Object} interview - The current interview object containing existing data
 * @param {string} pageName - The name of the page being submitted, used as the page status key
 * @param {boolean} isSaveAndExit - Whether this is a save and exit operation (creates activity request for Agent identity type only)
 * @param {Object} formData - Optional form data to be processed
 * @param {Function} [formDataToQuestionAnswers] - Optional function to transform form data into question answers format
 * @returns {Object} The formatted onboarding page submit request object
 * @returns {string} returns.identityType - The identity type passed through
 * @returns {Object} returns.interview - The updated interview with merged question answers and page status
 * @returns {Object|null} returns.activityRequest - Activity request object for save and exit operations (Agent only), null otherwise
 */
export function mapToOnboardingPageSubmitRequest(
    identityType,
    interview,
    pageName,
    isSaveAndExit,
    formData,
    formDataToQuestionAnswers
) {
    // Create activity request for save and exit operations
    const activityRequest = identityType === IdentityType.Agent && isSaveAndExit ? {
        ActivityCategory: "GEAO_ONBOARDING",
        ActivitySubType: "SAVE_AND_EXIT",
        SourceApplication: "AGIWUI",
        AdditionalData: {
            ComponentName: pageName
        }
    } : null;

    const updatedInterview = {
        ...interview,
        questionAnswers: {
            ...interview.questionAnswers,
            ...(formData && formDataToQuestionAnswers ? formDataToQuestionAnswers(formData) : {})
        },
        pageStatus: {
            ...interview?.pageStatus,
            [pageName]: PageStatus.Completed
        }
    };

    const onboardingPageSubmitRequest = {
        identityType: identityType,
        interview: updatedInterview,
        activityRequest: activityRequest
    };

    return onboardingPageSubmitRequest;
}